module.exports = __webpack_public_path__ + "img/partner-list-3.abe3421b.png";